<template>
  <div id="user__profile__modal">
    <div>
        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(saveUser)">
                <div class="row">
                    <div v-show="error" class="col-md-12 mb-3">
                        <div
                        class="alert alert-danger"
                        >Email address already in use. Please try a different email address.</div>
                    </div>
                    <div v-show="errorPw" class="col-md-12 mb-3">
                        <div
                        class="alert alert-danger" v-html="errorMessage"
                        ></div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                        <label>First Name</label>
                        <input type="text" v-model="loggedInUserData.first_name" class="form-control" ref="focusThis" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                        <label>Last Name</label>
                        <input type="text" v-model="loggedInUserData.last_name" class="form-control" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                        <label>Email*</label>
                        <ValidationProvider mode="passive" rules="required|email" v-slot="{ errors }">
                            <input type="text" v-model="loggedInUserData.email" class="form-control" :readonly="loggedInUserData.id != '' && loggedInUserData.email != ''" />
                            <span class="text-danger" v-for="(error, index) in errors" :key="index">{{ error }}</span>
                        </ValidationProvider>
                        </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <a href="#" class="" :class="psExpanded ? 'bordered-link': ''" @click.prevent="toggleRows">
                          <span> Set New Password
                            <i v-if="psExpanded" class="fas fa-chevron-up"></i>
                            <i v-else class="fas fa-chevron-down"></i>
                          </span>
                        </a>
                      </div>
                    </div>
                    <transition name="fade">
                      <div class="row m-0" v-if="psExpanded">
                        <div class="col-md-12 ">
                          <div class="row bordered-parent">
                            <!-- enter current password if editing password for current user -->
                            <div class="col-md-12 pr-0 pl-0" v-if="psExpanded && loggedInUserCompare">
                              <div class="form-group">
                                <label>Current Password*</label>
                                <ValidationProvider mode="passive" :rules="password != '' ? 'required' : ''"  v-slot="{ errors }">
                                  <input :type="showCurrentPassword ? 'text' : 'password'"
                                    v-model="currentPassword" class="form-control" />
                                  <span class="toggle-password top-55" @click="toggleCurrentPassword">
                                    <i v-if="showCurrentPassword" class="fas fa-eye"></i>
                                    <i v-else class="fas fa-eye-slash"></i>
                                  </span>
                                  <span class="text-danger" v-for="(error, index) in errors" :key="index">{{ error }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                            <div class="col-md-12 pr-0 pl-0" v-if="psExpanded">
                              <div class="form-group">
                                <label>New Password*</label>
                                <ValidationProvider mode="passive" :rules="!loggedInUserData.id ? 'required' : ''"  v-slot="{ errors }">
                                  <input :type="showPassword ? 'text' : 'password'"
                                    v-model="password" class="form-control"
                                    @input="validatePassword($event.target.value)" />
                                  <span class="toggle-password top-50" @click="togglePassword">
                                    <i v-if="showPassword" class="fas fa-eye"></i>
                                    <i v-else class="fas fa-eye-slash"></i>
                                  </span>
                                  <password v-model="password" :strength-meter-only="true" style="max-width: unset; margin: 0;" />
                                  <span class="text-danger" v-for="(error, index) in errors" :key="index">{{ error }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                            <div class="col-md-12 pr-0 pl-0" v-if="psExpanded">
                              <ul class="password-checklist">
                                <li :class="{ 'pw-list-item': true, 'pass': checkPwConditionReached('min') == 'pass', 'error': checkPwConditionReached('min') == 'err' }">
                                  <span class="pw-list-check"><i :class="`fas ${getPwListIcon('min')}`"></i></span> At least 8 letters
                                </li>
                                <li :class="{ 'pw-list-item': true, 'pass': checkPwConditionReached('uppercase') == 'pass', 'error': checkPwConditionReached('uppercase') == 'err' }">
                                  <span class="pw-list-check"><i :class="`fas ${getPwListIcon('uppercase')}`"></i></span> At least 1 capital letters
                                </li>
                                <li :class="{ 'pw-list-item': true, 'pass': checkPwConditionReached('lowercase') == 'pass', 'error': checkPwConditionReached('lowercase') == 'err' }">
                                  <span class="pw-list-check"><i :class="`fas ${getPwListIcon('lowercase')}`"></i></span> At least 1 lower case letters
                                </li>
                                <li :class="{ 'pw-list-item': true, 'pass': checkPwConditionReached('symbols') == 'pass', 'error': checkPwConditionReached('symbols') == 'err' }">
                                  <span class="pw-list-check"><i :class="`fas ${getPwListIcon('symbols')}`"></i></span> At least 1 special characters (!$#@%^*&amp;{}[]&lt;&gt;)
                                </li>
                                <li :class="{ 'pw-list-item': true, 'pass': checkPwConditionReached('digits') == 'pass', 'error': checkPwConditionReached('digits') == 'err' }">
                                  <span class="pw-list-check"><i :class="`fas ${getPwListIcon('digits')}`"></i></span> At least 1 numberic digits
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>

                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Roles*</label>
                            <ValidationProvider mode="passive" rules="required" v-slot="{ errors }">
                                <multiselect
                                v-model="loggedInUserData.userRoles"
                                :show-labels="false"
                                track-by="id"
                                label="name"
                                :options="allRoles"
                                :multiple="true"
                                :disabled="loggedInUserCompare"
                                ></multiselect>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group user--preferences--multiselect">
                            <label>Preferences</label>
                            <div>
                                <span v-show="!editing" @click="showEditPreference">
                                        <span v-if="!preferenceData.deliverable_type || !preferenceData.deliverable_type.length" class="exclude-outside-click cursor-pointer">
                                            Click to set deliverable type preference
                                        </span>
                                        <span v-else class="exclude-outside-click badge badge-gray cursor-pointer" :key="'user__preference__'+index+'__'+Math.random()" v-for="(preference, index) in preferenceData.deliverable_type">
                                            {{ preference.name }}
                                        </span>
                                    </span>
                                    <multiselect
                                    ref="userDeliverableType"
                                    v-click-outside="outside"
                                    v-model="preferenceData.deliverable_type"
                                    :show-labels="false"
                                    :options="preferenceDeliverableTypes"
                                    :multiple="true"
                                    v-show="editing"
                                    label="name"
                                    track-by="id"
                                    ></multiselect>
                            </div>
                        </div>
                    </div>
                    <div v-if="!enablePasswordEdit && !loggedInUserCompare" class="col-md-12">
                        <div class="form-group">
                        <label>Active: <switches v-model="loggedInUserData.is_enabled" theme="bootstrap" color="primary"></switches></label>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="d-flex update-profile-controls">
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit" data-dismiss="modal">Save</button>
                            </div>
                            <div class="form-group">
                                <a href="#" @click="toggleEnablePasswordEdit">
                                    <span Change password</span>
                                    <span v-if="enablePasswordEdit">Back to profile</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Switches from 'vue-switches';
import Password from 'vue-password-strength-meter';
import passwordValidator from 'password-validator';
import toast from "../../toast";

export default {
    data() {
        return {
        	errorMessage:'',
        	currentPassword: '',
            password: '',
            confirmPassword: '',
            editing: false,
            error: false,
            enablePasswordEdit: true,
			psExpanded: false,
            pwValidator: null,
            pwValidateList: [],
            pwValidateErrorList: [],

            errorPw: false,
            showCurrentPassword: false,
   		   showPassword: false,
        }
    },
    components: {
        Switches,
        Password
    },
    computed: {
        ...mapGetters(['preferenceData', 'preferenceDeliverableTypes', 'loggedInUserData', 'allRoles']),
        loggedInUserCompare() {
            return localStorage.getItem('userId') == this.loggedInUserData.id;
        }
    },
    methods: {
        ...mapActions(['savePreference']),
        outside() {
            this.editing = false;
        },
        showEditPreference() {
            this.editing = true
            this.$nextTick(() => {
                this.$refs.userDeliverableType.$el.focus()
            })
        },
        saveUser() {
            this.pwValidateErrorList = this.pwValidator.validate(this.password, { list: true });
            if (this.pwValidateErrorList.length > 0 && (this.password || this.currentPassword)) {
                return;
            }

            if(this.password) {
                this.loggedInUserData.password = this.password;
                this.loggedInUserData.currentPassword = this.currentPassword;
            }
            this.loggedInUserData.preferences = this.preferenceData.deliverable_type;
            let that = this;
            this.$store.dispatch("updateProfile", this.loggedInUserData).then(function (resp) {
                that.showUpdateUser = false;
                that.errorMessage = "Invalid password";
                if (resp.data == false) {
                    that.error = true;
                } else if (resp.data == 'invalid_password') {
                    that.errorPw = true;
                } else if (resp.data == 'invalid_password') {
                    that.errorPw = true;
                } else if (resp.data == 'invalid_current_password') {
                  that.hasError = true;
                  that.errorPw = true;
                	that.errorMessage = "Invalid current password.";
                } else {
                    that.error = false;
                    that.errorPw = false;
                    // if(that.enablePasswordEdit) {
                    //     that.$root.$emit('logout');
                    // } else {
                        that.$bvModal.hide("userProfileModal");
                    // }
                }
            });
        },

        // Hardcoded password requirement
    toggleRows() {
      this.psExpanded = !this.psExpanded;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleCurrentPassword() {
      this.showCurrentPassword = !this.showCurrentPassword;
    },
        initPasswordValidator() {
            if (!this.pwValidator) {
                this.pwValidator = new passwordValidator();

                this.pwValidator.is().min(8).has().uppercase().has().lowercase().has().digits(1).has().symbols();
                this.pwValidateList = this.pwValidator.validate('', { list: true });
            }
        },
        validatePassword(password) {
            this.initPasswordValidator();
            this.pwValidateList = this.pwValidator.validate(password, { list: true });
            this.pwValidateErrorList = this.pwValidateErrorList.filter(x => this.pwValidateList.includes(x));
        },
        checkPwConditionReached(name) {
            if (this.pwValidateErrorList.includes(name)) {
                return 'err';
            }
            if (!this.pwValidateList.includes(name)) {
                return 'pass';
            }

            return 'pending'
        },
        getPwListIcon(name) {
            let code = this.checkPwConditionReached(name);
            if (code == 'err') {
                return 'fa-times';
            }
            if (code == 'pass') {
                return 'fa-check';
            }
            return 'fa-circle';
        },

        toggleEnablePasswordEdit() {
            this.enablePasswordEdit = !this.enablePasswordEdit;
            if (!this.enablePasswordEdit) {
                this.password = "";
                this.confirmPassword = "";
                this.pwValidateList = this.pwValidator.validate('', { list: true });
                this.pwValidateErrorList = [];
            }

            this.$root.$emit("userProfileTitleChange", {enablePasswordEdit: this.enablePasswordEdit});
        }
    },
    mounted() {
        this.initPasswordValidator();
    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease-in;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
.toggle-password {
  position: absolute;
  right: 1.5rem;
  transform: translateY(-50%);
  cursor: pointer;
}

.top-50 {
  top: 50%;
}

.top-55 {
  top: 55%;
}

.bordered-link {
  display: block;
  /* border-bottom: 1px solid #ced4da; */
}

.bordered-parent {
  margin: 0px;
  /* border: 1px solid #ced4da; */
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-top: none;
  border-radius: 2px;
  /* margin-top: -16px;
  margin-bottom: 1rem; */
}

a:hover {
  text-decoration: none;
}
</style>